import * as React from "react"
import * as whyStyles from "./why.module.css"

/*
 * The four claims in the band under the hero. Each is a short label over the
 * value that backs it up, so the payload — the year, the lines, the lead
 * time, the reach — is the part that gets the display size.
 *
 * Kept as data rather than four copies of the same markup so the stagger
 * delay can come from the index.
 */
const PILLARS = [
  { label: "Logística", value: "100% local" },
  /* The range, not a list. "Linhas de produto — Malhas · Entretelas" claimed
     to enumerate and did not: the estamparia was missing, and naming all
     three lines runs to three lines of display type against the 16ch cap on
     `.value`. The fibres bracket the catalogue instead — poliamida,
     poliéster, viscose and algodão on the malharia side, linho among the
     printing bases — and stay true as it grows. */
  { label: "Fibras", value: "Poliamida a algodão" },
  { label: "Impressão digital", value: "Sob demanda" },
  { label: "Em operação desde", value: "1974" },
]

/* The index is the number, rather than each entry carrying its own: they read
   01–04 down the row whatever order the claims are in, so reordering the list
   above is the whole edit. */
const numberOf = index => String(index + 1).padStart(2, "0")

/*
 * The same reveal preset the Amaré page uses — one restrained fade-and-rise —
 * with the handoff's 80ms stagger between columns.
 */
const reveal = (delay = 0) => ({
  "data-sal": "slide-up",
  "data-sal-delay": delay,
  "data-sal-easing": "ease-out-circ",
  "data-sal-duration": 1200,
})

export default function Why() {
  return (
    <section className={whyStyles.band}>
      <div className={whyStyles.wrap}>
        {PILLARS.map(({ label, value }, i) => (
          <div className={whyStyles.pillar} key={label} {...reveal(i * 80)}>
            <span className={whyStyles.num}>{numberOf(i)}</span>
            <span className={whyStyles.rule}></span>
            <p className={whyStyles.label}>{label}</p>
            <p className={whyStyles.value}>{value}</p>
          </div>
        ))}
      </div>
    </section>
  )
}
